import { jsx } from 'react/jsx-runtime';
import cn from 'classnames/bind';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const InputFooter = ({ message, isError = true }) => {
    const CustomTag = isError ? 'output' : 'span';
    return (jsx("div", { className: cx('cactus-input-footer__wrapper'), children: jsx("div", { className: cx('message-wrapper'), children: jsx(CustomTag, { className: cx('message', 'size-small', isError ? 'error' : 'info'), children: message }) }) }));
};

export { InputFooter };
//# sourceMappingURL=index.js.map
